<template>
  <div style="width: 100%;height: 100%;">
    <div class="map-page" id="chart-map-gas">
    </div>
    <div class="switch-map-btn">
          <div class="top-j">
          </div>
          <a href="javascript:;" class="btn-content" @click="change">
            <i class="iconfont icon-you"></i>
            切换到图表
          </a>
          <div class="bottom-j">
          </div>
        </div>
  </div>
</template>

<script>
import { initGasOption, setDataGasOption } from '@/mapTools'
import {
  axiosSysApi
} from '@/axios_init'
import {
  gas
} from '@/api/oli_api'
window.echarts = require('echarts')

window.myGasChat = null

export default {
  data () {
    return {
      gasLocation: null,
      gasData: []
    }
  },
  mounted () {
    window.initMapGas = this.initCharGas
    let chat = window.echarts.init(document.getElementById('chart-map-gas'))
    window.myGasChat = chat
    this.loadBdmapApi()
  },
  created () {
    this.getLocationData()
  },
  methods: {
    change () {
      this.$router.push({name: 'oil_chart'})
    },
    loadBdmapApi () {
      let script = document.createElement('script')
      script.src = 'https://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMapGas'
      document.body.appendChild(script)
    },
    getLocationData () {
      // 加油站、油库位置数据
      axiosSysApi.get('/static/location.json').then((response) => {
        this.gasLocation = response.data['加油站位置']
        this.getGasData()
      })
    },
    getGasData () {
      let vm = this
      let parm = {
        action: 'get_order_map_data',
        data: ''
      }
      gas(parm).then((data) => {
        let mapData = []
        let mapData2 = []
        for (let key in data) {
          if (key in vm.gasLocation) {
            data[key]['total'] = data[key]['total'].toFixed(2)
            if (Number(data[key]['xgdx'])) {
              mapData2.push({name: key, value: [...vm.gasLocation[key], data[key]]})
            } else {
              mapData.push({name: key, value: [...vm.gasLocation[key], data[key]]})
            }
          }
        }
        setDataGasOption('gas_nom', mapData)
        setDataGasOption('gas_xgdx', mapData2)
      })
    },
    initCharGas () {
      window.myGasChat.clear()
      window.myGasChat.setOption(initGasOption(), true)
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.map-page {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #000;
}
.switch-map-btn {
  z-index: 20;
  position: absolute;
  display: flex;
  top: 20rem;
  right: 0;
  width: 1.3rem;
  flex-direction:column;
  line-height: 1.1;
}
.icon-qiehuan3:before { content: "\e61d"; }
.top-j {
  flex: 1;
  width: 0;
  height: 0;
  border-bottom: 0.6rem solid #486881;
  border-left: 1.3rem solid transparent; 
}
.bottom-j {
  flex: 1;
  width: 0;
  height: 0;
  border-top: 0.6rem solid #486881;
  border-left: 1.3rem solid transparent; 
}
.btn-content {
  padding: 3px 0;
  background-color: #486881;
  text-align: center;
  color: #fff;
  font-size: 0.75rem;
  i {
    line-height: 1.3;
    font-size: 1rem;
  }
}
</style>

<style lang="less">
.anchorBL {
  display: none;
}
</style>



// WEBPACK FOOTER //
// gas_map.vue?7f86531e